import type { TFunction } from "i18next";
import { useTranslation } from "react-i18next";

import { cn } from "~/components/ui/cn";
import { ComplainsIcon } from "~/components/ui/icons/complains";
import { OrderTagClaim } from "~/graphql/graphql-new.gen";

import { OrderBadge } from "./order-badge";

export const getOrderClaimLabelFromTag = (tag: OrderTagClaim, t: TFunction) => {
  switch (tag) {
    case OrderTagClaim.Opened:
      return t("order.status.claim.open");
    case OrderTagClaim.Closed:
      return t("order.status.claim.closed");
  }
};

const variant = ({
  isCancelled,
  tag,
}: {
  isCancelled?: boolean;
  tag: OrderTagClaim;
}) => {
  if (isCancelled) return "default";
  return tag === OrderTagClaim.Opened ? "danger" : "default";
};

export const OrderClaimBadge: React.FC<{
  isCancelled?: boolean;
  tag: OrderTagClaim;
}> = ({ isCancelled, tag }) => {
  const { t } = useTranslation();

  if (tag === OrderTagClaim.None) return null;

  return (
    <OrderBadge variant={variant({ isCancelled, tag })}>
      <div className="flex items-center gap-x-1">
        {tag === OrderTagClaim.Opened ? (
          <ComplainsIcon className="size-3.5" />
        ) : null}
        <span className={cn({ "line-through": isCancelled })}>
          {getOrderClaimLabelFromTag(tag, t)}
        </span>
      </div>
    </OrderBadge>
  );
};
